// extracted by mini-css-extract-plugin
export default {"cell-container":"CellLogMessage_cell-container__9BzDF","cell-message":"CellLogMessage_cell-message__1AONi","cell-link":"CellLogMessage_cell-link__rjk0h"};